/* eslint-disable prefer-destructuring */
import i18n from '@i18next/i18n';
import { ActionType } from './common-action-type';
import { opacityToAlpha, TDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';

export const DraggableTypes = {
    UI_ELEMENT: 'UI_ELEMENT',
};

export const ParagraphStyles = [
    'Heading 1',
    'Heading 2',
    'Heading 3',
    'Body',
    'Body Small',
    'Caption',
];

export const SpringSettings = {
    DRAG: {
        stiffness: 1000,
        damping: 50,
    },
    RESIZE: {
        stiffness: 210,
        damping: 20,
    },
};

export const SNAP_DISTANCE = 6;
export const BLACKLIST_CURRENT_ELEMENT_DESELECT = 'ignoreElementDeselect';

export const COORDINATE = {
    LEFT_TOP: 'LEFT_TOP',
    LEFT_MID: 'LEFT_MID',
    LEFT_BOT: 'LEFT_BOT',
    TOP_LEFT: 'TOP_LEFT',
    TOP_MIDD: 'TOP_MIDD',
    TOP_RIGT: 'TOP_RIGT',
};

export const CodeLanguages = {
    cpp: 'C/C++',
    cs: 'C#',
    css: 'CSS',
    fsharp: 'F#',
    go: 'Go',
    haskell: 'Haskell',
    java: 'Java',
    javascript: 'JavaScript',
    jsx: 'JSX',
    julia: 'Julia',
    xml: 'XML/HTML',
    matlab: 'MATLAB',
    php: 'PHP',
    python: 'Python',
    r: 'R',
    ruby: 'Ruby',
    scala: 'Scala',
    sql: 'SQL',
    yaml: 'YAML',
};

export const CodeThemes = {
    tomorrowNight: 'Dark',
    tomorrow: 'Light',
};


// 渐变填充相关数据
export const AngleList = [
    {
        angle: 0, title: i18n.t('0°(向右)'), val: {
            x1: 0, y1: 0, x2: 1, y2: 0,
        },
    },
    {
        angle: 45, title: '45°', val: {
            x1: 0, y1: 0, x2: 1, y2: 1,
        },
    },
    {
        angle: 90, title: '90°', val: {
            x1: 0, y1: 0, x2: 0, y2: 1,
        },
    },
    {
        angle: 135, title: '135°', val: {
            x1: 1, y1: 0, x2: 0, y2: 1,
        },
    },
    {
        angle: 180, title: '180°', val: {
            x1: 1, y1: 0, x2: 0, y2: 0,
        },
    },
    {
        angle: 225, title: '225°', val: {
            x1: 1, y1: 1, x2: 0, y2: 0,
        },
    },
    {
        angle: 270, title: '270°', val: {
            x1: 0, y1: 1, x2: 0, y2: 0,
        },
    },
    {
        angle: 315, title: '315°', val: {
            x1: 0, y1: 1, x2: 1, y2: 0,
        },
    },
];
export const DirectList = [
    {
        id: 'rightBottom', rect: {
            b: 0, l: 100, r: 0, t: 100,
        }, title: i18n.t('从右下角'), val: { cx: 1, cy: 1, r: 2 }, angle: 45, position: '100% 100%',
        tileRect: {
            b: -100, l: 0, r: -100, t: 0,
        },
    },
    {
        id: 'leftBottom', rect: {
            b: 0, l: 0, r: 100, t: 100,
        }, title: i18n.t('从左下角'), val: { cx: 0, cy: 1, r: 2 }, angle: 135, position: '0% 100%',
        tileRect: {
            b: -100, l: -100, r: 0, t: 0,
        },
    },
    {
        id: 'center', rect: {
            b: 50, l: 50, r: 50, t: 50,
        }, title: i18n.t('从中心'), val: { cx: 0.5, cy: 0.5, r: 1 },
        tileRect: {
            b: 0, l: 0, r: 0, t: 0,
        },
    },
    {
        id: 'rightTop', rect: {
            b: 100, l: 100, r: 0, t: 0,
        }, title: i18n.t('从右上角'), val: { cx: 1, cy: 0, r: 2 }, angle: 315, position: '100% 0%',
        tileRect: {
            b: 0, l: 0, r: -100, t: -100,
        },
    },
    {
        id: 'leftTop', rect: {
            b: 100, l: 0, r: 100, t: 0,
        }, title: i18n.t('从左上角'), val: { cx: 0, cy: 0, r: 2 }, angle: 225, position: '0% 0%',
        tileRect: {
            b: 0, l: -100, r: 0, t: -100,
        },
    },
    {
        id: 'bottomTop', rect: {
            b: -30, l: 50, r: 50, t: 130,
        }, title: i18n.t('从正下方'), val: { cx: 0.5, cy: 1.3, r: 1.5 }, angle: 90,
        tileRect: {
            b: -100, l: 0, r: 0, t: 0,
        },
    },
    {
        id: 'topBottom', rect: {
            b: 180, l: 50, r: 50, t: -80,
        }, title: i18n.t('从正上方'), val: { cx: 0.5, cy: -0.3, r: 1.5 }, angle: 270,
        tileRect: {
            b: 0, l: 0, r: 0, t: -100,
        },
    },
];

export const LinearDirectList = [
    {
        angle: 45,
        title: i18n.t('左上到右下'),
        range: [1, 89],
    },
    {
        angle: 90,
        title: i18n.t('线性向下'),
        range: [90, 90],
    },
    {
        angle: 135,
        title: i18n.t('右上到左下'),
        range: [91, 179],
    },
    {
        angle: 0,
        title: i18n.t('线性向右'),
        range: [0, 0],
    },
    {
        angle: 180,
        title: i18n.t('线性向左'),
        range: [180, 180],
    },
    {
        angle: 315,
        title: i18n.t('左下到右上'),
        range: [271, 359],
    },
    {
        angle: 270,
        title: i18n.t('线性向上'),
        range: [270, 270],
    },
    {
        angle: 225,
        title: i18n.t('右下到左上'),
        range: [181, 269],
    },
];

export function getLinearDirection(angle?: number) {
    if (!angle) {
        return LinearDirectList[3];
    }
    return LinearDirectList.filter(item => (item.range[0] <= angle && angle <= item.range[1]))[0];
}

export const RectDirectList = [
    {
        rect: {
            b: 0, l: 100, r: 0, t: 100,
        },
        tileRect: {
            b: -100, l: 0, r: -100, t: 0,
        },
        title: i18n.t('从右下角'),
    },
    {
        rect: {
            b: 0, l: 0, r: 100, t: 100,
        },
        tileRect: {
            b: -100, l: -100, r: 0, t: 0,
        },
        title: i18n.t('从左下角'),
    },
    {
        rect: {
            b: 50, l: 50, r: 50, t: 50,
        },
        tileRect: {
            b: 0, l: 0, r: 0, t: 0,
        },
        title: i18n.t('从中心'),
    },
    {
        rect: {
            b: 100, l: 100, r: 0, t: 0,
        },
        tileRect: {
            b: 0, l: 0, r: -100, t: -100,
        },
        title: i18n.t('从右上角'),
    },
    {
        rect: {
            b: 100, l: 0, r: 100, t: 0,
        },
        tileRect: {
            b: 0, l: -100, r: 0, t: -100,
        },
        title: i18n.t('从左上角'),
    },
];

export function getRectDirection(fillToRect) {
    const direction = RectDirectList.filter(item => item.rect.b === fillToRect?.b
        && item.rect.l === fillToRect?.l
        && item.rect.r === fillToRect?.r
        && item.rect.t === fillToRect?.t)[0];
    if (direction) {
        return direction;
    }
    return RectDirectList[2];
}

export const ShapeDirectionList = [{
    rect: {
        b: 50, l: 50, r: 50, t: 50,
    },
    title: i18n.t('从中心'),
    tileRect: {
        b: 0, l: 0, r: 0, t: 0,
    },
}];

export const MirrorImageType = [
    { id: 'none', title: i18n.t('无') },
    { id: 'x', title: i18n.t('水平') },
    { id: 'y', title: i18n.t('垂直') },
    { id: 'xy', title: i18n.t('两者') },
];

// 对齐方式，tl,tr,bl,br,t,l,ctr,r,b
export const ImageAlign = [
    { id: 'tl', title: i18n.t('左上对齐') },
    { id: 't', title: i18n.t('靠上') },
    { id: 'tr', title: i18n.t('右上对齐') },
    { id: 'l', title: i18n.t('靠左') },
    { id: 'ctr', title: i18n.t('居中') },
    { id: 'r', title: i18n.t('靠右') },
    { id: 'bl', title: i18n.t('左下对齐') },
    { id: 'b', title: i18n.t('靠下') },
    { id: 'br', title: i18n.t('右下对齐') },
];

export function getMirrorType(id) {
    for (let i = 0; i < MirrorImageType.length; i++) {
        const item = MirrorImageType[i];
        if (item.id === id) {
            return item;
        }
    }
    return MirrorImageType[0];
}

let imageAlignMap;
export function getImageAlign(id) {
    if (!imageAlignMap) { // 初始化map
        imageAlignMap = new Map();
        ImageAlign.forEach((item) => {
            imageAlignMap.set(item.id, item);
        });
    }
    let value = imageAlignMap.get(id);
    if (!value) {
        value = imageAlignMap.get('tl');
    }
    return value;
}

// const extraDirectList = [
//     {id:'bottomTop',rect:{b:-30,l:50,r:50,t:130},title:'正下方',val:{cx:0.5,cy:1.3,r:1.5},angle:90},
//     {id:'topBottom',rect:{b:180,l:50,r:50,t:-80},title:'正上方',val:{cx:0.5,cy:-0.6,r:1.5},angle:270},
// ]

export function getConfigByAndle(angle) {
    if (angle) {
        for (let i = 0; i < AngleList.length; i++) {
            const item = AngleList[i];
            if (item.angle === angle) {
                return item;
            }
        }
    }
    return AngleList[0];
}

export function getConfigByRect(fillToRect) {
    if (fillToRect) {
        for (let i = 0; i < DirectList.length; i++) {
            const item = DirectList[i];
            if (item.rect.b === fillToRect.b && item.rect.l === fillToRect.l
                && item.rect.r === fillToRect.r && item.rect.t === fillToRect.t) {
                return item;
            }
        }
        // for (let i = 0; i<extraDirectList.length;i++){
        //     let item = extraDirectList[i];
        //     if(item.rect.b === fillToRect.b && item.rect.l === fillToRect.l &&
        //         item.rect.r === fillToRect.r && item.rect.t === fillToRect.t){
        //         return item;
        //     }
        // }
    }
    return DirectList[2];
}

// 边框相关数据。
// val是线端类型为非butt的值，val2为butt的值
export const BorderStyle = [
    {
        style: 'solid', title: i18n.t('实线'), val: '', val2: '',
    },
    {
        style: 'sysDot', title: i18n.t('虚线：点线'), val: '0 2', val2: '1 1',
    },
    {
        style: 'sysDash', title: i18n.t('虚线：短划1'), val: '2 2', val2: '3 1',
    },
    {
        style: 'dash', title: i18n.t('虚线：短划2'), val: '3 4', val2: '4 3',
    },
    {
        style: 'dashDot', title: i18n.t('虚线：短划2+点'), val: '3 4 0 4', val2: '4 3 1 3',
    },
    {
        style: 'lgDash', title: i18n.t('虚线：长划'), val: '6 4', val2: '7 3',
    },
    {
        style: 'lgDashDot', title: i18n.t('虚线：长划+点'), val: '6 4 0 4', val2: '7 3 1 3',
    },
    {
        style: 'lgDashDotDot', title: i18n.t('虚线：长划+点x2'), val: '6 4 0 4 0 4', val2: '7 3 1 3 1 3',
    },
];

export const EffectPropsField = {
    /** 效果通用 */
    STYLE: {
        name: 'style', title: i18n.t('预设'),
    },
    COLOR: {
        name: 'color', title: i18n.t('颜色'),
    },
    TD_COLOR: {
        name: 'tdColor', title: i18n.t('颜色'),
    },
    OPACITY: {
        name: 'opacity', title: i18n.t('透明度'),
    },
    SIZE: {
        name: 'size', title: i18n.t('大小'),
    },
    BLURRINESS: {
        name: 'blurRad', title: i18n.t('模糊'),
    },
    ANGLE: {
        name: 'dir', title: i18n.t('角度'),
    },
    DISTANCE: {
        name: 'dist', title: i18n.t('距离'),
    },
    ROTATE_WITH_SHAPE: {
        name: 'rotWithShape',
    },
    ALGN: {
        name: 'algn',
    },
    SIZE_X: {
        name: 'sizeX',
    },
    SIZE_Y: {
        name: 'sizeY',
    },
    SKEW_X: {
        name: 'skewX',
    },

    /** 映像专用 */
    STARTOPACITY: {
        name: 'startOpacity', title: i18n.t('透明度'),
    },
    ENDOPACITY: {
        name: 'endOpacity',
    },
    SCALEY: {
        name: 'sy',
    },
};

export const DefaultEffectPresetProps = {
    [ActionType.SHADOW]: {
        [EffectPropsField.COLOR.name]: '#000000',
        [EffectPropsField.TD_COLOR.name]: new TDColor({ rgbaStr: '#000000', alpha: opacityToAlpha(60) }),
        [EffectPropsField.OPACITY.name]: 60,
        [EffectPropsField.SIZE.name]: 100,
        [EffectPropsField.BLURRINESS.name]: 6,
        [EffectPropsField.ANGLE.name]: 45,
        [EffectPropsField.DISTANCE.name]: 10,
        [EffectPropsField.ROTATE_WITH_SHAPE.name]: 0,   // 外阴影rotWithShape默认为false
        isOuter: true,
    },
    [ActionType.REFLECTION]: {
        [EffectPropsField.STARTOPACITY.name]: 48,
        [EffectPropsField.ENDOPACITY.name]: 99.7,
        [EffectPropsField.SIZE.name]: 35,
        [EffectPropsField.BLURRINESS.name]: 0,
        [EffectPropsField.DISTANCE.name]: 0,
        [EffectPropsField.SCALEY.name]: -1,
        [EffectPropsField.ANGLE.name]: 90,
        [EffectPropsField.ROTATE_WITH_SHAPE.name]: 0,
    },
    [ActionType.GLOW]: {
        [EffectPropsField.COLOR.name]: '#000000',
        [EffectPropsField.TD_COLOR.name]: new TDColor({ rgbaStr: '#000000', alpha: opacityToAlpha(60) }),
        [EffectPropsField.OPACITY.name]: 60,
        [EffectPropsField.SIZE.name]: 25,
    },
    [ActionType.SOFTEDGE]: {
        [EffectPropsField.SIZE.name]: 10,
    },
};


export const OuterShadowPresetStyleList = [
    /** 外部，顺序不能变 */
    {
        style: 'outer-45', title: i18n.t('偏移：右下'), key: 'outer-45',
    },
    {
        style: 'outer-90', title: i18n.t('偏移：下'), key: 'outer-90',
    },
    {
        style: 'outer-135', title: i18n.t('偏移：左下'), key: 'outer-135',
    },
    {
        style: 'outer-0', title: i18n.t('偏移：右'), key: 'outer-0',
    },
    {
        style: 'outer-0-phai', title: i18n.t('偏移：中'), key: 'outer-0-phai',
    },
    {
        style: 'outer-180', title: i18n.t('偏移：左'), key: 'outer-180',
    },
    {
        style: 'outer-315', title: i18n.t('偏移：右上'), key: 'outer-315',
    },
    {
        style: 'outer-270', title: i18n.t('偏移：上'), key: 'outer-270',
    },
    {
        style: 'outer-225', title: i18n.t('偏移：左上'), key: 'outer-225',
    },
];

export const InnerShadowPresetStyleList = [
    /** 内部, 顺序不能变 */
    {
        style: 'inner-225', title: i18n.t('内部：左上'), key: 'inner-225',
    },
    {
        style: 'inner-270', title: i18n.t('内部：上'), key: 'inner-270',
    },
    {
        style: 'inner-315', title: i18n.t('内部：右上'), key: 'inner-315',
    },
    {
        style: 'inner-180', title: i18n.t('内部：左'), key: 'inner-180',
    },
    {
        style: 'inner-0-phai', title: i18n.t('内部：中'), key: 'inner-0-phai',
    },
    {
        style: 'inner-0', title: i18n.t('内部：右'), key: 'inner-0',
    },
    {
        style: 'inner-135', title: i18n.t('内部：左下'), key: 'inner-135',
    },
    {
        style: 'inner-90', title: i18n.t('内部：下'), key: 'inner-90',
    },
    {
        style: 'inner-45', title: i18n.t('内部：右下'), key: 'inner-45',
    },
];

export const PerspectiveShadowPresetStyleList = [
    /** 内部, 顺序不能变 */
    {
        style: 'perspective-1', title: i18n.t('透视：左上'), key: 'perspective-1',
    },
    {
        style: 'perspective-2', title: i18n.t('透视：右上'), key: 'perspective-2',
    },
    {
        style: 'perspective-3', title: i18n.t('透视：下'), key: 'perspective-3',
    },
    {
        style: 'perspective-4', title: i18n.t('透视：左下'), key: 'perspective-4',
    },
    {
        style: 'perspective-5', title: i18n.t('透视：右下'), key: 'perspective-5',
    },
];

export const ReflectionPresetStyleList = [
    {
        style: 'close-0-dy', title: i18n.t('紧密映像： 接触'), key: 'close-0-dy',
    },
    {
        style: 'close-4-dy', title: i18n.t('紧密映像： 4磅 偏移量'), key: 'close-4-dy',
    },
    {
        style: 'close-8-dy', title: i18n.t('紧密映像： 8磅 偏移量'), key: 'close-8-dy',
    },
];

export const SoftEdgePresetStyleList = [
    {
        style: 'soft-10', title: i18n.t('边缘柔化变体： 10磅'), key: 'soft-10',
    },
    {
        style: 'soft-25', title: i18n.t('边缘柔化变体： 25磅'), key: 'soft-25',
    },
    {
        style: 'soft-50', title: i18n.t('边缘柔化变体： 50磅'), key: 'soft-50',
    },
];

export const GlowPresetStyleList = [
    {
        style: 'glow-1', title: i18n.t('发光： 灰色1： 11磅'), key: '#000000-80',
    },
    {
        style: 'glow-2', title: i18n.t('发光： 金色1： 11磅'), key: '#F64848-80',
    },
    {
        style: 'glow-3', title: i18n.t('发光： 金色2： 11磅'), key: '#FFE64D-80',
    },
    {
        style: 'glow-4', title: i18n.t('发光： 金色3： 11磅'), key: '#FDE525-80',
    },
    {
        style: 'glow-5', title: i18n.t('发光： 绿色1： 11磅'), key: '#B2E922-80',
    },
    {
        style: 'glow-6', title: i18n.t('发光： 紫色1： 11磅'), key: '#D041E1-80',
    },
    {
        style: 'glow-7', title: i18n.t('发光： 紫色2： 11磅'), key: '#A98DFD-80',
    },
    {
        style: 'glow-8', title: i18n.t('发光： 蓝色1： 11磅'), key: '#547CF8-80',
    },
    {
        style: 'glow-9', title: i18n.t('发光： 蓝色2： 11磅'), key: '#03C3FF-80',
    },
];

// 线端类型
export const StrokeLineCap = [
    { type: 'flat', name: i18n.t('平'), val: 'butt' }, // 平会导致虚线的绘制值计算改变.暂时先去掉,后续需要可以支持
    { type: 'sq', name: i18n.t('方'), val: 'square' },
    { type: 'rnd', name: i18n.t('圆'), val: 'round' },
];
export type ILineCap = 'butt' | 'square' | 'round';

// 连接类型
export const StrokeLineJoin = [
    { type: 'miter', name: i18n.t('斜角'), val: 'miter' },
    { type: 'round', name: i18n.t('圆角'), val: 'round' },
    { type: 'bevel', name: i18n.t('棱台'), val: 'bevel' },
];
export type ILineJoin = 'miter' | 'round' | 'bevel';

const borderMap = new Map();
export function getBorderStyle(style) {
    if (borderMap.size === 0) {
        BorderStyle.forEach((item) => {
            borderMap.set(item.style, item);
        });
    }
    let v = borderMap.get(style);
    if (!v) {
        v = BorderStyle[0];
    }
    return v;
}

const lineCapMap = new Map();
export function getLineCap(type) {
    if (lineCapMap.size === 0) {
        StrokeLineCap.forEach((item) => {
            lineCapMap.set(item.type, item);
        });
    }
    let v = lineCapMap.get(type);
    if (!v) {
        v = StrokeLineCap[0];
    }
    return v;
}

const lineJoinMap = new Map();
export function getLineJoin(type, isTextOrPlaceholder) {
    if (lineJoinMap.size === 0) {
        StrokeLineJoin.forEach((item) => {
            lineJoinMap.set(item.type, item);
        });
    }
    let v = lineJoinMap.get(type);
    if (!v) {
        if (!isTextOrPlaceholder) {
            v = StrokeLineJoin[0];
        } else {
            v = StrokeLineJoin[1];
        }
    }
    return v;
}


export const LEFT_BAR_WIDTH = 200;
export const LEFT_BAR_CONTENT_WIDTH = 180;
export const PROPERTY_EDITOR_WIDTH = 268;
export const TITLE_BAR_HEIGHT = 40;
export const SINGLE_TOOLBAR_HEIGHT = 52;
export const DOUBLE_TOOLBAR_HEIGHT = 110;
export const SINGLE_TOOLBAR_HEAD_HEIGHT = TITLE_BAR_HEIGHT + SINGLE_TOOLBAR_HEIGHT;
export const DOUBLE_TOOLBAR_HEAD_HEIGHT = TITLE_BAR_HEIGHT + DOUBLE_TOOLBAR_HEIGHT;
export const DRAWER_PROPERTY_EDITOR_WIDTH = 280;
export const DRAWER_PROPERTY_EDITOR_RIGHT_MARGIN = 8;
export const STATUS_BAR_HEIGHT = 32;
export const MAX_DRAWER_PROPERTY_EDITOR_WIDTH = 320;

export const NOTE_MIN_HEIGHT = 49;
export const NOTE_MAX_HEIGHT = 526;
export const NOTE_DEFAULT_HEIGHT = 80;
export const MOBILE_NOTE_DEFAULT_HEIGHT = 80;
export const NOTE_COLLAPSE_HEIGHT = 8;
export const NOTE_START_COLLAPSE_HEIGHT = 29;

export const ONE_THOUSAND_MILLISECONDS = 1000; // 1000毫秒

export const UPLOAD_PICTURE_OCR_ID = 'upload-picture-formula-ocr';
export const UPLOAD_FILE_INPUT = 'upload-file-input';

// 标尺容器宽度/高度
export const RULER_LENGTH = 14;

// 接入wb后不再需要docs-scenario-components-pc-top-menu包，但是部分业务依赖了这个包的常量，因此复制一份到本地，用于阉割gzip体积
export const DefaultActions = {
    DIVIDER: 'divider-menu-item',  // 分割线ID

    // 顶部菜单-------------------------------
    // 文档信息
    DOC_INFO: 'doc-info-menu-item',
    // 文件菜单项id
    NEW: 'new-menu-sub',
    ONLINE_DOC: 'online-doc-menu-item',
    ONLINE_SHEET: 'online-sheet-menu-item',
    ONLINE_SLIDE: 'online-slide-menu-item',
    ONLINE_COLLECT: 'online-collect-menu-item',
    NEW_FILE: 'new-file-menu-item',
    // 导入文件
    IMPORT_DOC: 'import-doc-menu-item',
    // 帮助与反馈
    HELP_FEEDBACK: 'help-feedback-sub',
    APPEAL: 'appeal-menu-item',
    HELP: 'help-menu-item',
    ABOUT: 'about-menu-item',
};
export const MenuEvents = {
    MOUNTED: 'mounted',
    MENU_HIDE: 'menu-hide',
    MENU_SHOW: 'menu-show',
    BUTTON_HOVER: 'button-hover',
};

